import React from 'react';
import logo from './logo.svg';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FPMain from '../main/FPMain';
import FPList from '../fplist/FPList';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<FPMain />} />
        <Route path='/fplist' element={<FPList />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;